const Constants = {
  Index: '/',
  Data: '/data',
  Contribute: '/contribute',
  NotFound: '/notfound',
  SignUp: '/join',
  SignIn: '/login',
  SignOut: '/logout',
  ForgotPassword: '/forgot',
  ConfirmEmail: '/verify',
  ResetPassword: '/reset',
  Terms: '/terms',
  Privacy: '/privacy',
};

export default Constants;
